import { useEffect, useState } from 'react';
import { Headphones } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  getSiteLanguage,
  subscribeSiteLanguage,
  type SiteLanguageCode,
} from '@/lib/language';

const LABELS: Record<SiteLanguageCode, { idle: string; loading: string }> = {
  en: { idle: 'Connect to Human', loading: 'Connecting…' },
  hi: { idle: 'मानव से जुड़ें', loading: 'जोड़ रहे हैं…' },
};

export function ConnectHumanButton({
  onClick,
  disabled,
  loading,
  className,
}: {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}) {
  const [language, setLanguage] = useState<SiteLanguageCode>(() => getSiteLanguage());

  useEffect(() => subscribeSiteLanguage(setLanguage), []);

  const labels = LABELS[language];

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={disabled || loading}
      className={cn('gap-1.5 rounded-full text-[12px] h-8', className)}
    >
      <Headphones className="h-3.5 w-3.5 shrink-0" />
      {loading ? labels.loading : labels.idle}
    </Button>
  );
}
